import { createFileRoute } from "@tanstack/react-router"
import { getGetResourceQueryKey, ResourceDto } from "@/orval/gen"
import { ResourceDetailsPage } from "./-components/ResourceDetailsPage"

export const Route = createFileRoute("/app/resources/$id")({
  component: ResourceDetailsPage,
  beforeLoad: ({ context: { queryClient }, params: { id } }) => ({
    getTitle: () =>
      queryClient?.getQueryData<ResourceDto>(
        getGetResourceQueryKey({
          resourceId: parseInt(id),
        })
      )?.name,
  }),
})
